import permohonanApi from '../../services/permohonanApi'

const SET_PERMOHONAN = "SET_PERMOHONAN"
const SET_ALL_PERMOHONAN = "SET_ALL_PERMOHONAN"
const SET_FILTER_PERMOHONAN = "SET_FILTER_PERMOHONAN"
const SET_DATA_PERMOHONAN = "SET_DATA_PERMOHONAN"
const SET_META_PERMOHONAN = "SET_META_PERMOHONAN"
const SET_RIWAYAT_DATA_PERMOHONAN = "SET_RIWAYAT_DATA_PERMOHONAN"
const SET_FILE_PERMOHONAN = "SET_FILE_PERMOHONAN"
const SET_PENDUDUK_BANTU = "SET_PENDUDUK_BANTU"
const SET_IS_RESET_PERMOHONAN = "SET_IS_RESET_PERMOHONAN"
const SET_HASIL_PERMOHONAN = "SET_HASIL_PERMOHONAN"
const SET_BACK_TO = "SET_BACK_TO"

const state = {
	permohonan: [], // list permohonan yang sudah difilter
	allPermohonan: null, // list permohonan semuanya, tanpa filter
	dataPermohonan: { // data permohonan yang mau dibuat / di view
		tahap: 1,
	},
    metaPermohonan: {
        current_page: 1,
        per_page: 10,
        from: null,
        to: null,
        total: null
    },
	riwayatDataPermohonan: null,
	filePermohonan: null,
	filterPermohonan: {
		status: null
	},
	pendudukBantu: null, // penduduk yang dibantu input oleh operator,

	// halaman buat permohonan diakses dari menu, atau lanjutin dari riwayat
	// kalau dari menu, dia reset dulu dataPermohonannnya
	// kalau dari riwayat, gak reset
	isResetPermohonan: true,
	hasilPermohonan: null,
	backto: null, // di detail permohonan, kalau tombol back diklik bisa balik ke data permohonan/riwayat input
}

const mutations = {
	[SET_PERMOHONAN](state, data) {
		state.permohonan = data
	},
	[SET_ALL_PERMOHONAN](state, data) {
		state.allPermohonan = data
	},
	[SET_FILTER_PERMOHONAN](state, data) {
		state.filterPermohonan = data
	},
	[SET_DATA_PERMOHONAN](state, data) {
		state.dataPermohonan = data
	},
	[SET_META_PERMOHONAN](state, data) {
		state.metaPermohonan = data
	},
	[SET_RIWAYAT_DATA_PERMOHONAN](state, data) {
		state.riwayatDataPermohonan = data
	},
	[SET_FILE_PERMOHONAN](state, data) {
		state.filePermohonan = data
	},
	[SET_PENDUDUK_BANTU](state, data) {
		state.pendudukBantu = data
	},
	[SET_IS_RESET_PERMOHONAN](state, data) {
		state.isResetPermohonan = data
	},
	[SET_HASIL_PERMOHONAN](state, data) {
		state.hasilPermohonan = data
	},
	[SET_BACK_TO](state, data) {
		state.backto = data
	}
}

const actions = {
	async fetchPermohonanPenduduk({ getters }) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPermohonanPenduduk(token)
	},
	async fetchPaginatePermohonanPenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPaginatePermohonanPenduduk(token, data)
	},
	async getAllStatusPermohonanPenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.getAllStatusPermohonanPenduduk(token, data)
	},
	async fetchPermohonanDesa({ getters }) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPermohonanDesa(token)
	},
	async fetchPaginatePermohonanDesa({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPaginatePermohonanDesa(token, data)
	},
	async fetchPaginatePermohonanRumahSakit({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPaginatePermohonanRumahSakit(token, data)
	},
	async getAllStatusPermohonanDesa({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.getAllStatusPermohonanDesa(token, data)
	},
	async getAllStatusPermohonanDesaRiwayatInput({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.getAllStatusPermohonanDesaRiwayatInput(token, data)
	},
	async getAllStatusPermohonanRumahSakit({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.getAllStatusPermohonanRumahSakit(token, data)
	},
	async getAllStatusPermohonanRumahSakitRiwayatInput({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.getAllStatusPermohonanRumahSakitRiwayatInput(token, data)
	},
	async fetchRiwayatInputDesa({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchRiwayatInputDesa(token, data)
	},
	async fetchRiwayatInputRumahSakit({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchRiwayatInputRumahSakit(token, data)
	},
	async fetchPermohonanKecamatan({ getters }) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPermohonanKecamatan(token)
	},
	async fetchPaginatePermohonanKecamatan({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPaginatePermohonanKecamatan(token, data)
	},
	async getAllStatusPermohonanKecamatan({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.getAllStatusPermohonanKecamatan(token, data)
	},
	async fetchPermohonanDukcapil({ getters }) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPermohonanDukcapil(token)
	},
	async fetchPaginatePermohonanDukcapil({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchPaginatePermohonanDukcapil(token, data)
	},
	async getAllStatusPermohonanDukcapil({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.getAllStatusPermohonanDukcapil(token, data)
	},
	setPermohonan({ commit }, data) {
		commit(SET_PERMOHONAN, data)
		commit(SET_ALL_PERMOHONAN, data)
	},
	setFilterPermohonan({ commit }, data) {
		commit(SET_FILTER_PERMOHONAN, data)
	},
	filterPermohonan({ getters, commit }) {
		let filter = getters.getFilterPermohonan

		let allPermohonan = getters.getAllPermohonan
		let tmpPermohonan = []
		if (filter.status != null) {
			allPermohonan.forEach(e => {
				if (e.status === filter.status) {
					tmpPermohonan.push(e)
				}
			})
		} else {
			tmpPermohonan = allPermohonan
		}

		// console.log('tmpPermohonan', tmpPermohonan)
		commit(SET_PERMOHONAN, tmpPermohonan)
	},
	setDataPermohonan({ commit }, data) {
		// disini belum nyimpen ke db
		commit(SET_DATA_PERMOHONAN, data)
	},
	setRiwayatDataPermohonan({ commit }, data) {
		// disini belum nyimpen ke db
		commit(SET_RIWAYAT_DATA_PERMOHONAN, data)
	},
	async fetchFileDataPermohonan({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchFileDataPermohonan(token, id)
	},
	async fetchFilePermohonanByRs({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchFilePermohonanByRs(token, id)
	},
	async fetchFilePermohonanByDesa({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchFilePermohonanByDesa(token, id)
	},
	async fetchFilePermohonanByKecamatan({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchFilePermohonanByKecamatan(token, id)
	},
	async fetchFilePermohonanByDukcapil({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchFilePermohonanByDukcapil(token, id)
	},
	setFilePermohonan({ commit }, data) {
		commit(SET_FILE_PERMOHONAN, data)
	},

	async uploadSuratPengantar({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.uploadSuratPengantar(token, data.id, data.form)
	},
	async uploadBerkasPermohonan({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.uploadBerkasPermohonan(token, data)
	},
	async updateBerkasPermohonan({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.updateBerkasPermohonan(token, data.id, data.data)
	},
	async hapusBerkasPermohonan({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.hapusBerkasPermohonan(token, id)
	},
	async storePermohonanPenduduk({ getters }, data) {
		// permohonan dibuat ketika sudah pilih paket dan layanannya
		let token = getters.getAuthService.token
		return await permohonanApi.storePermohonanPenduduk(token, data)
	},
	async storePermohonanPendudukByDesa({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.storePermohonanPendudukByDesa(token, data)
	},
	async storePermohonanPendudukByRumahSakit({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.storePermohonanPendudukByRumahSakit(token, data)
	},
	async updatePermohonanPenduduk({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.updatePermohonanPenduduk(token, data.id, data.form)
	},
	async showDataPermohonanPenduduk({ getters, commit, dispatch }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.showDataPermohonanPenduduk(token, id).then(res => {
			if (res.data.status) {
				commit(SET_DATA_PERMOHONAN, res.data.data)
			} else {
				// console.log(res.data)
				alert('Data tidak ditemukan')
				window.location.href = '/permohonan/data-permohonan'
			}
		})
    .catch((err) => {
      try {
        if (err.response.status === 401) {
          dispatch('logoutUser')
          window.location = '/login'
        } else {
          alert('error')
          window.location.href = '/'
        }
      } catch (e) {
        alert('error')
        window.location.href = '/'
      }
    })
	},
	async showDataPermohonanPendudukByDesa({ getters, commit, dispatch }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.showDataPermohonanPendudukByDesa(token, id).then(res => {
			if (res.data.status) {
				commit(SET_DATA_PERMOHONAN, res.data.data)
			} else {
				alert('Data tidak ditemukan')
				window.location.href = '/permohonan/data-permohonan'
			}
		})
    .catch((err) => {
      try {
        if (err.response.status === 401) {
          dispatch('logoutUser')
          window.location = '/login'
        } else {
          alert('error')
          window.location.href = '/'
        }
      } catch (e) {
        alert('error')
        window.location.href = '/'
      }
    })
	},
	async showDataPermohonanPendudukByRumahSakit({ getters, commit, dispatch }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.showDataPermohonanPendudukByRumahSakit(token, id).then(res => {
			if (res.data.status) {
				commit(SET_DATA_PERMOHONAN, res.data.data)
			} else {
				alert('Data tidak ditemukan')
				window.location.href = '/permohonan/data-permohonan'
			}
		})
    .catch((err) => {
      try {
        if (err.response.status === 401) {
          dispatch('logoutUser')
          window.location = '/login'
        } else {
          alert('error')
          window.location.href = '/'
        }
      } catch (e) {
        alert('error')
        window.location.href = '/'
      }
    })
	},
	async showDataPermohonanPendudukByKecamatan({ getters, commit, dispatch }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.showDataPermohonanPendudukByKecamatan(token, id).then(res => {
			if (res.data.status) {
				commit(SET_DATA_PERMOHONAN, res.data.data)
			} else {
				alert('Data tidak ditemukan')
				window.location.href = '/permohonan/data-permohonan'
			}
		})
    .catch((err) => {
      try {
        if (err.response.status === 401) {
          dispatch('logoutUser')
          window.location = '/login'
        } else {
          alert('error')
          window.location.href = '/'
        }
      } catch (e) {
        alert('error')
        window.location.href = '/'
      }
    })
	},
	async showDataPermohonanPendudukByDukcapil({ getters, commit, dispatch }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.showDataPermohonanPendudukByDukcapil(token, id).then(res => {
			if (res.data.status) {
				commit(SET_DATA_PERMOHONAN, res.data.data)
			} else {
				alert('Data tidak ditemukan')
				window.location.href = '/permohonan/data-permohonan'
			}
		})
      .catch((err) => {
        try {
          if (err.response.status === 401) {
            dispatch('logoutUser')
            window.location = '/login'
          } else {
            alert('error')
            window.location.href = '/'
          }
        } catch (e) {
          alert('error')
          window.location.href = '/'
        }
      })
	},
	async showRiwayatDataPermohonan({ getters, commit }, id) { // id_data_permohonan
		let token = getters.getAuthService.token
		return await permohonanApi.showRiwayatDataPermohonan(token, id)
	},
	async hapusPermohonanPenduduk({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.hapusPermohonanPenduduk(token, id)
	},
	async hapusPermohonanPendudukByDesa({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.hapusPermohonanPendudukByDesa(token, id)
	},
	async hapusPermohonanPendudukByAdmin({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.hapusPermohonanPendudukByAdmin(token, id)
	},
	async batalkanPermohonanPenduduk({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.batalkanPermohonanPenduduk(token, id)
	},
	async batalkanPermohonanPendudukByDesa({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.batalkanPermohonanPendudukByDesa(token, id)
	},
	async validasiPermohonanByDesa({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.validasiPermohonanByDesa(token, data.id, data.form)
	},
	async validasiPermohonanByKecamatan({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.validasiPermohonanByKecamatan(token, data.id, data.form)
	},
	async validasiPermohonanByDukcapil({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.validasiPermohonanByDukcapil(token, data.id, data.form)
	},
	setPendudukBantu({ commit }, data) {
		commit(SET_PENDUDUK_BANTU, data)
	},
	async validasiFilePermohonanByDesa({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.validasiFilePermohonanByDesa(token, data.id, data.form)
	},
	async validasiFilePermohonanByRs({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.validasiFilePermohonanByRs(token, data.id, data.form)
	},
	async validasiFilePermohonanByKecamatan({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.validasiFilePermohonanByKecamatan(token, data.id, data.form)
	},
	async validasiFilePermohonanByDukcapil({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.validasiFilePermohonanByDukcapil(token, data.id, data.form)
	},
	setIsResetPermohonan({ commit }, data) {
		commit(SET_IS_RESET_PERMOHONAN, data)
	},
	async fetchHasilPermohonan({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchHasilPermohonan(token, id)
	},
	async fetchHasilPermohonanByOperator({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.fetchHasilPermohonanByOperator(token, id)
	},
	setHasilPermohonan({ commit }, data) {
		commit(SET_HASIL_PERMOHONAN, data)
	},
	async storeHasilPermohonanByOperator({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.storeHasilPermohonanByOperator(token, data)
	},
	async updateHasilPermohonanByOperator({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.updateHasilPermohonanByOperator(token, data.id, data.form)
	},
	async deleteHasilPermohonanByOperator({ getters }, id) {
		let token = getters.getAuthService.token
		return await permohonanApi.deleteHasilPermohonanByOperator(token, id)
	},
	async setBerkasTambahan({ getters }, data) {
		let token = getters.getAuthService.token
		return await permohonanApi.setBerkasTambahan(token, data)
	}
}

const getters = {
	getPermohonan: state => {
		return state.permohonan
	},
	getAllPermohonan: state => {
		return state.allPermohonan
	},
	getFilterPermohonan: state => {
		return state.filterPermohonan
	},
	getDataPermohonan: state => {
		return state.dataPermohonan
	},
	getMetaPermohonan: state => {
		return state.metaPermohonan
	},
	getRiwayatDataPermohonan: state => {
		return state.riwayatDataPermohonan
	},
	getFilePermohonan: state => {
		return state.filePermohonan
	},
	getPendudukBantu: state => {
		return state.pendudukBantu
	},
	getIsResetPermohonan: state => {
		return state.isResetPermohonan
	},
	getHasilPermohonan: state => {
		return state.hasilPermohonan
	},
	getBackTo: state => {
		return state.backto
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}